import { graphql } from "../../gql/gql";

export const RESPONSE_CREATE = graphql(/* GraphQL */ `
  mutation ResponseCreate($data: ResponseCreateInput!) {
    responseCreate(data: $data) {
      id
      slug
    }
  }
`);
